// import React from "react";
// import Services from "../../api/Services";
// import ServiceCard from "./ServiceCard"


// const ServiceSection = (props) => {


//     return (
//         <section className="helpas-service-section section-padding">
//             <div className="container">
//                 <div className="row">
//                     {Services.slice(0, 4).map((Service, sitem) => (
//                         <div 
//                             className="
//                                         col-lg-3 col-md-6 col-12 
//                                         .serviceCardWrapper {
//                                         transition: transform 0.3s ease-in-out; /* Thêm transition cho hiệu ứng mượt mà */
//                                         }

//                                         .serviceCardWrapper:hover {
//                                         animation: swingUpDown 1s ease-in-out infinite alternate;
//                                         }

//                                         @keyframes swingUpDown {
//                                         0% {
//                                             transform: translateY(0);
//                                         }
//                                         50% {
//                                             transform: translateY(-5px);
//                                         }
//                                         100% {
//                                             transform: translateY(0);
//                                         }
//                                         }
//                                     " 
//                             key={sitem}
//                         >
//                             <ServiceCard title={Service.title} img={Service.sImg} slug={Service.slug} sdescription={Service.description} />
//                         </div>
//                     ))}

//                 </div>
//             </div>
//         </section>
//     );
// }

// export default ServiceSection;

import React from "react";
import Services from "../../api/Services";
import ServiceCard from "./ServiceCard";
import styles from "./ServiceSection.module.css"; // Import CSS module (nếu bạn tạo file ServiceSection.module.css)

const ServiceSection = (props) => {
    return (
        <section className="helpas-service-section section-padding">
            <div className="container">
                <div className="row">
                    {Services.slice(0, 4).map((Service, sitem) => (
                        <div
                            className={`col-lg-3 col-md-6 col-12`} // Thêm class CSS
                            key={sitem}
                        >
                            <ServiceCard
                                title={Service.title}
                                img={Service.sImg}
                                slug={Service.slug}
                                sdescription={Service.description}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ServiceSection;